var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.statusesWithIcons.includes(_vm.status))?_c('i',{staticClass:"pointer",class:_vm.statusIconClass,on:{"click":_vm.toggle}}):_vm._e()}
var staticRenderFns = []

export { render, staticRenderFns }